import type { Profile, StaffRole } from "@amazing-care/types";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./use-auth";

/**
 * The caller's profile row, which is the single source of truth for their role.
 * The prototype read the role from a `?role=` query param; nothing in the UI
 * may decide permissions that way any more.
 */
export function useProfile() {
  const { adapter, user, isLoading: isAuthLoading } = useAuth();

  const query = useQuery<Profile | null>({
    queryKey: ["profile", user?.id],
    queryFn: () => (user ? adapter.getProfile(user.id) : Promise.resolve(null)),
    enabled: !!user,
    staleTime: 1000 * 60 * 5,
  });

  const role: StaffRole | null = query.data?.role ?? null;

  return {
    profile: query.data ?? null,
    role,
    isLoading: isAuthLoading || query.isLoading,
    error: query.error,
  };
}
